import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface FindReplacePayload {
  find: string;
  replace: string;
  caseSensitive?: boolean;
  target?: 'note' | 'jotdoc';
  jotdocId?: string;
}

export interface FindReplaceState {
  action: FindReplacePayload | null;
}

const initialState: FindReplaceState = { action: null };

const findReplaceSlice = createSlice({
  name: 'findReplace',
  initialState,
  reducers: {
    setFindReplace(state, action: PayloadAction<FindReplacePayload>) {
      state.action = action.payload;
    },
    clearFindReplace(state) {
      state.action = null;
    },
  },
});

export const { setFindReplace, clearFindReplace } = findReplaceSlice.actions;
export default findReplaceSlice.reducer;
